import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Util from 'utility';
import { __ } from 'locale';

function SeminarWorkHeader({
    lectureInfo,
    seminarWorkData,
    onSave,
    onLoad,
    onOpenLongtermEvaluation,
}) {
    const data = useSelector(state => state);
    const history = useHistory();

    const lectureId = Number(data.appModeData.lectureId);
    const isSk = Util.getLang() === 'sk';
    const taskNoun = Util.getLectureTaskDishTerm(data.appModeData?.lectureInfoData, 'nom', true);

    let dayNames = {
        "Den 1": "Pondělí", "Den 2": "Úterý", "Den 3": "Středa", "Den 4": "Čtvrtek",
        "Den 5": "Pátek", "Den 6": "Sobota", "Den 7": "Neděle",
    };

    if (isSk) {
        dayNames = {
            "Den 1": "Pondelok", "Den 2": "Utorok", "Den 3": "Streda", "Den 4": "Štvrtok",
            "Den 5": "Piatok", "Den 6": "Sobota", "Den 7": "Nedeľa",
        };
    }

    const seminarDays = Object.keys(seminarWorkData.lectures || {}).map(l => {
        const dayLectureId = Number(l);
        const isActive = lectureId === dayLectureId;
        const lectureTitle = seminarWorkData.lectures[l];
        const dayLabel = dayNames[lectureTitle] || lectureTitle || l;

        return (
            <a
                key={l}
                className={`block py-1.5 px-4 text-sm cursor-pointer hover:bg-slate-50 border-b border-slate-100 last:border-b-0 ${isActive ? 'font-bold text-green-600' : 'text-slate-600'}`}
                onClick={() => history.push('/load/seminarwork-task/' + dayLectureId)}
            >
                {dayLabel}
            </a>
        );
    });

    let courseTitle = 'Vypracování seminární práce';
    if (seminarWorkData.is_assignment === 1) {
        courseTitle = 'Zadání seminární práce';
    }

    if (isSk) {
        courseTitle = 'Vypracovanie seminárnej práce';
        if (seminarWorkData.is_assignment === 1) {
            courseTitle = 'Zadanie seminárnej práce';
        }
    }

    const currentDayLabel = dayNames[lectureInfo.title] || lectureInfo.title || taskNoun;
    const showSaveLoadButtons = seminarWorkData.is_assignment !== 1;

    return (
        <>
            <div className="min-w-0">
                <p className="text-xs text-slate-400 uppercase font-semibold tracking-wide mb-0.5">{courseTitle}</p>
                <h1 className="text-xl font-bold text-slate-800 leading-tight mt-0.5 flex items-center gap-2">
                    {taskNoun}:
                    <div className="relative">
                        <label htmlFor="seminar-work-day-title-cb" className="cursor-pointer text-green-600 hover:text-green-700 underline">
                            {currentDayLabel}
                        </label>
                        <input className="peer hidden" type="checkbox" id="seminar-work-day-title-cb" />
                        <div className="hidden peer-checked:block absolute z-[1500] left-0 top-[calc(100%+6px)] bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden min-w-[140px]">
                            {seminarDays}
                        </div>
                    </div>
                </h1>
            </div>
            <div className="flex gap-2 flex-wrap items-center shrink-0 pt-1">
                {showSaveLoadButtons && (
                    <>
                        <a className="whitespace-nowrap bg-green-500 py-2 px-4 rounded-lg border border-green-500 text-white no-underline flex items-center text-sm font-medium cursor-pointer hover:bg-green-600 transition-colors shadow-sm gap-1.5" onClick={onSave}>
                            <i className="fa fa-save text-xs"></i>
                            {__('Uložit')}
                        </a>
                        <a className="whitespace-nowrap bg-white py-2 px-4 rounded-lg border border-slate-200 text-slate-700 no-underline flex items-center text-sm font-medium cursor-pointer hover:bg-slate-50 transition-colors shadow-sm gap-1.5" onClick={onLoad}>
                            <i className="fa fa-folder-open text-xs"></i>
                            {__('Načíst')}
                        </a>
                    </>
                )}
                <a className="whitespace-nowrap bg-green-500 py-2 px-4 rounded-lg border border-green-500 text-white no-underline flex items-center text-sm font-medium cursor-pointer hover:bg-green-600 transition-colors shadow-sm gap-1.5" onClick={onOpenLongtermEvaluation}>
                    <i className="fa fa-chart-bar text-xs"></i>
                    {__('Dlouhodobé vyhodnocení')}
                </a>
            </div>
        </>
    );
}

export default SeminarWorkHeader;
